import { DownloadIcon } from '@chakra-ui/icons'
import { Flex, IconButton, Text, Tooltip } from '@chakra-ui/react'
import { AssessmentDocument, isSignableDocument, SignableDocument } from '@hb/shared'
import { useMemo } from 'react'

export const DocumentDownloadButton = ({
  // withDownload,
  onDownload,
  downloadLoading,
  document,
  bottom = '-38px',
  right = '16px',
  top,
}: {
  // withDownload: boolean | undefined
  onDownload: () => Promise<void>
  downloadLoading: boolean
  document: AssessmentDocument | SignableDocument | undefined
  bottom?: number | string
  right?: number | string
  top?: number | string
}) => {
  const downloadText = useMemo(() => {
    if (document && isSignableDocument(document)) {
      return document.signedStoragePath
        ? 'Downloading signed document...'
        : 'Downloading document...'
    }
    return 'Generating PDF...'
  }, [document])
  return (
    <Flex
      pos="absolute"
      alignItems="center"
      // bottom={readOnly ? '-40px' : '-32px'}
      // right={readOnly ? '52px' : '14px'}
      zIndex={3}
      bottom={bottom}
      right={right}
      top={top}>
      <Flex align="center">
        <Tooltip hasArrow placement="right" bg="gray.600" label={downloadLoading ? '' : 'Download'}>
          <IconButton
            size="sm"
            color="white"
            isLoading={downloadLoading}
            aria-label="download"
            borderRadius="full"
            bg="blackAlpha.400"
            _hover={{ bg: 'blackAlpha.600' }}
            onClick={onDownload}
            icon={<DownloadIcon />}
          />
        </Tooltip>
        <Text
          opacity={downloadLoading ? 1 : 0}
          transition="opacity 500ms"
          pointerEvents="none"
          color="gray.400"
          position="absolute"
          right="120%"
          whiteSpace="nowrap"
          fontSize="xs">
          {downloadText}
        </Text>
      </Flex>
    </Flex>
  )
}
